var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_450)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4201 25.2198C34.0101 25.2198 33.6701 24.8798 33.6701 24.4698V21.1499C33.6701 19.9099 32.6601 18.8999 31.4201 18.8999H17.5801C17.1701 18.8999 16.8301 18.5599 16.8301 18.1499C16.8301 17.7399 17.1701 17.3999 17.5801 17.3999H31.4201C33.4901 17.3999 35.1701 19.0799 35.1701 21.1499V24.4698C35.1701 24.8898 34.8301 25.2198 34.4201 25.2198Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7401 22.07C20.5501 22.07 20.3601 21.9999 20.2101 21.8499L17.0501 18.69C16.9101 18.55 16.8301 18.3599 16.8301 18.1599C16.8301 17.9599 16.9101 17.77 17.0501 17.63L20.2101 14.4699C20.5001 14.1799 20.9801 14.1799 21.2701 14.4699C21.5601 14.7599 21.5601 15.24 21.2701 15.53L18.6401 18.1599L21.2701 20.7899C21.5601 21.0799 21.5601 21.5599 21.2701 21.8499C21.1201 21.9899 20.9301 22.07 20.7401 22.07Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4201 32.59H20.5801C18.5101 32.59 16.8301 30.91 16.8301 28.84V25.52C16.8301 25.11 17.1701 24.77 17.5801 24.77C17.9901 24.77 18.3301 25.11 18.3301 25.52V28.84C18.3301 30.08 19.3401 31.09 20.5801 31.09H34.4201C34.8301 31.09 35.1701 31.43 35.1701 31.84C35.1701 32.25 34.8301 32.59 34.4201 32.59Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2602 35.7501C31.0702 35.7501 30.8802 35.6801 30.7302 35.5301C30.4402 35.2401 30.4402 34.7601 30.7302 34.4701L33.3602 31.8401L30.7302 29.2101C30.4402 28.9201 30.4402 28.4401 30.7302 28.1501C31.0202 27.8601 31.5002 27.8601 31.7902 28.1501L34.9502 31.3101C35.0902 31.4501 35.1702 31.6401 35.1702 31.8401C35.1702 32.0401 35.0902 32.2301 34.9502 32.3701L31.7902 35.5301C31.6502 35.6801 31.4602 35.7501 31.2602 35.7501Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_450",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_450",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvesting);
export default __webpack_public_path__ + "static/media/investing.dc3a0eb60ab8b55f8933574eab9c288b.svg";
export { ForwardRef as ReactComponent };